<div class="dc-modal">
  <div class="dc-modal-container bg-white min-w-3xs! max-w-[450px]!">
    <div class="text-center">
      <h2 class="text-xl font-semibold text-dc-navy">
        <!--
         {{ "TOAST_MESSAGES.SUCCESS" | translate  }}</span> -->
           <span class="text-center"><img src="/icons/svg/success.svg" class="m-auto" /></span>
          {{ "TOAST_MESSAGES.REQUEST_SUBMITTED_DRAFT" | translate }}
      </h2>
      
      <p class="p-2 text-dc-navy! font-semibold">
        {{ "TOAST_MESSAGES.REFERENCE_NO" | translate }} <span class="font-normal ref-number"> {{srNumber}}</span>
      </p>
       <p class="p-2 text-dc-navy!">   
          {{ "TOAST_MESSAGES.GOTO_MY_APPLICATION" | translate }}
      </p>
    </div>
    <div class="flex gap-3 justify-center">      
      <app-button
        type="button"
        classesName="btn-edge-cut btn-width-auto"
        [label]="'BUTTONS.CLOSE' | translate"
        (onBtnClick)="closeSuccessModal()"
      ></app-button>
    </div>
  </div>
</div>